import React from "react";
import * as Sentry from "@sentry/react";

import "./styles.sass";
import { sentryLogForAllowedWorkspaces } from "./services/SentryService/sentryLogForAllowedWorkspaces";
import { SmartdocWidget } from "./components/SmartdocWidget";
import { AppConfigProvider } from "./context/AppConfigContext";
import { useIncomingDocConfig } from "./hooks/useIncomingDocConfig";
import { useAppDomState } from "./hooks/useAppDomState";

export const App: React.FC = () => {
  const { config, ready, setReportLabel } = useIncomingDocConfig();
  useAppDomState(config, ready);

  if (!ready) {
    return null;
  }

  return (
    <Sentry.ErrorBoundary
      onError={() => {
        sentryLogForAllowedWorkspaces(config);
      }}
      fallback={<div>Something went wrong. Please try again later.</div>}
    >
      <AppConfigProvider config={config} setReportLabel={setReportLabel}>
        <SmartdocWidget />
      </AppConfigProvider>
    </Sentry.ErrorBoundary>
  );
};

export default App;
